import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.assign";
import _slicedToArray from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.set";
import "core-js/modules/es6.typed.float64-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.object.freeze";
// The shape rules for every tool that draws a polygon (#205): the fans' shape step (create area), the owners' free draw
// (create and edit a community), the server's save methods, and any drawing tool to come. One copy, so a rule never
// differs between the screen that draws and the method that saves. How and why: docs/claude/explain/drawing-guards.md.
//
// Pure: no Meteor, no Vue, no Leaflet. Client import: `api/polygons/shapeRules`. Points are [lat, lng] (Leaflet's
// order) in an open ring (no closing duplicate); a GeoJSON ring is [lng, lat] and closed.
//
// Three kinds of rule:
//  - the ring rules (ringRejectReason): what MongoDB needs to index and match the shape. Every tool, always.
//  - the shape rules (checkShape): points, crossing, size and point count, with the limits of the tool (SHAPE_LIMITS).
//  - the drag guards (rejectReasonForVertex): refuse a dragged point that would spoil the shape. For tools that start
//    from a clean shape and only move its points (the fans' 8-gon); free drawing cannot use them (D27).
// The limits per kind of drawing. A null limit is not checked. mergeDistanceM is what the editors merge (cleanRing)
// before they check; the server never merges: it refuses a corner used twice.
export var SHAPE_LIMITS = Object.freeze({
  // derived from the 33 production communities (D27): every one of them passes. Smallest 100 m², largest
  // 1,190,505 ha, up to 4,128 points, corners down to 0.19° (so no angle rule), shortest real segment 1.9 m
  community: Object.freeze({
    minPoints: 3,
    maxPoints: 5000,
    minAreaM2: 50,
    maxAreaM2: 2000000 * 10000,
    // 2,000,000 ha
    mergeDistanceM: 0.5
  }),
  // a fan's area: an 8-gon from the level's circle, from a street to the world, so no size limits; its drag guards
  // keep it from collapsing. The old PBL survey's drawing tool (removed in #509) split a crossing drawing into parts (turf's
  // unkink), and those areas are stored, so a fan's area may be a MultiPolygon, each part held to the same rules
  fanArea: Object.freeze({
    minPoints: 3,
    maxPoints: 5000,
    minAreaM2: null,
    maxAreaM2: null,
    mergeDistanceM: 0.5,
    multiPolygon: true
  })
}); // ---- measuring ----
// Leaflet's distance (haversine on its earth radius), so the numbers match what the map measures

var EARTH_RADIUS_M = 6371000; // the area on the sphere as @mapbox/geojson-area measures it (WGS84 radius), the numbers the free draw always showed

var AREA_RADIUS_M = 6378137;

var rad = function rad(d) {
  return d * Math.PI / 180;
};

export var distanceM = function distanceM(a, b) {
  var dLat = rad(b[0] - a[0]);
  var dLng = rad(b[1] - a[1]);
  var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return 2 * EARTH_RADIUS_M * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}; // surface in m² on the sphere (Chamberlain & Duquette, as geojson-area)

export var areaM2 = function areaM2(points) {
  var n = (points || []).length;
  if (n < 3) return 0;
  var sum = 0;

  for (var i = 0; i < n; i++) {
    var p1 = points[i];
    var p2 = points[(i + 1) % n];
    var p3 = points[(i + 2) % n];
    sum += (rad(p3[1]) - rad(p1[1])) * Math.sin(rad(p2[0]));
  }

  return Math.abs(sum * AREA_RADIUS_M * AREA_RADIUS_M / 2);
};
export var polygonCentroid = function polygonCentroid(points) {
  if (!points || !points.length) return [0, 0];
  var lat = 0;
  var lng = 0;

  for (var i = 0; i < points.length; i++) {
    lat += points[i][0];
    lng += points[i][1];
  }

  return [lat / points.length, lng / points.length];
}; // ---- crossing ----
// do segments a-b and c-d cross or touch on the map's picture (a corner on the other segment, or the two overlapping on
// one line: MongoDB refuses a ring that touches itself as it refuses a crossing). Only ever asked for segments that
// share no corner

var crossOnMap = function crossOnMap(a, b, c, d) {
  var turn = function turn(p, q, r) {
    var v = (q[1] - p[1]) * (r[0] - q[0]) - (q[0] - p[0]) * (r[1] - q[1]);
    return v > 0 ? 1 : v < 0 ? -1 : 0;
  }; // q lies on segment p-r, given the three are on one line


  var within = function within(p, q, r) {
    return q[0] <= Math.max(p[0], r[0]) && q[0] >= Math.min(p[0], r[0]) && q[1] <= Math.max(p[1], r[1]) && q[1] >= Math.min(p[1], r[1]);
  };

  var t1 = turn(a, b, c);
  var t2 = turn(a, b, d);
  var t3 = turn(c, d, a);
  var t4 = turn(c, d, b);
  if (t1 !== t2 && t3 !== t4) return true;
  return t1 === 0 && within(a, c, b) || t2 === 0 && within(a, d, b) || t3 === 0 && within(c, a, d) || t4 === 0 && within(c, b, d);
}; // MongoDB joins two corners by the shortest way over the globe (a great circle), not by the straight line on the map:
// a side of 100 km at 52° bows about 250 m north of the map's line. A corner just past such a side on the map's picture
// can be across it for MongoDB, which then refuses the ring (#7, tried on MongoDB 4.0). So two sides cross when they do
// on the map (exact for the touching cases) or on the globe (below, the way MongoDB's S2 tests it).


var toXYZ = function toXYZ(p) {
  var lat = rad(p[0]);
  var lng = rad(p[1]);
  var c = Math.cos(lat);
  return [c * Math.cos(lng), c * Math.sin(lng), Math.sin(lat)];
};

var crossProd = function crossProd(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
};

var dotProd = function dotProd(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}; // a corner closer to a side than this (radians, about 6 µm) touches it


var TOUCH_RAD = 1e-12; // one side on the globe: its ends, its plane's normal and that normal's length

var arcOf = function arcOf(A, B) {
  var n = crossProd(A, B);
  return {
    A: A,
    B: B,
    n: n,
    len: Math.sqrt(dotProd(n, n))
  };
}; // does P lie on the arc (on its great circle and between its ends)


var onArc = function onArc(P, arc) {
  return Math.abs(dotProd(arc.n, P)) < TOUCH_RAD * arc.len && dotProd(crossProd(arc.A, P), arc.n) > 0 && dotProd(crossProd(P, arc.B), arc.n) > 0;
};

var crossOnGlobe = function crossOnGlobe(s, t) {
  if (!s.len || !t.len) return false;
  if (onArc(t.A, s) || onArc(t.B, s) || onArc(s.A, t) || onArc(s.B, t)) return true; // S2's SimpleCrossing: the ends of each side lie on both sides of the other's great circle, on the near crossing

  var acb = -dotProd(s.n, t.A);
  var bda = dotProd(s.n, t.B);
  if (acb * bda <= 0) return false;
  var cbd = -dotProd(t.n, s.B);
  var dac = dotProd(t.n, s.A);
  return acb * cbd > 0 && acb * dac > 0;
}; // do segments a-b and c-d ([lat, lng]) cross or touch, on the map or on the globe. Only ever asked for segments that
// share no corner


export var lineSegmentsIntersect = function lineSegmentsIntersect(a, b, c, d) {
  return crossOnMap(a, b, c, d) || crossOnGlobe(arcOf(toXYZ(a), toXYZ(b)), arcOf(toXYZ(c), toXYZ(d)));
}; // the pairs of edges of a closed ring of n edges whose boxes meet (box: dims × [min, max] per edge), edges that share a
// corner left out: a sweep along the axis the shape is longest in (a strip along a coast overlaps itself on the other),
// so a shape of 5,000 points does not test its 12.5 million pairs

var anyMeetingPair = function anyMeetingPair(n, dims, box, test) {
  var w = 2 * dims;
  var axis = 0;
  var widest = -1;

  for (var k = 0; k < w; k += 2) {
    var lo = Infinity;
    var hi = -Infinity;

    for (var i = 0; i < n; i++) {
      if (box[w * i + k] < lo) lo = box[w * i + k];
      if (box[w * i + k + 1] > hi) hi = box[w * i + k + 1];
    }

    if (hi - lo > widest) {
      widest = hi - lo;
      axis = k;
    }
  }

  var order = Array.from({
    length: n
  }, function (_, i) {
    return i;
  }).sort(function (a, b) {
    return box[w * a + axis] - box[w * b + axis];
  });

  for (var oi = 0; oi < n; oi++) {
    var _i = order[oi];
    var p = w * _i;

    for (var oj = oi + 1; oj < n; oj++) {
      var j = order[oj];
      var q = w * j;
      if (box[q + axis] > box[p + axis + 1]) break;
      var gap = Math.abs(_i - j);
      if (gap === 1 || gap === n - 1) continue;
      var meet = true;

      for (var _k = 0; _k < w && meet; _k += 2) {
        meet = _k === axis || box[q + _k] <= box[p + _k + 1] && box[p + _k] <= box[q + _k + 1];
      }

      if (meet && test(_i, j)) return [_i, j];
    }
  }

  return null;
}; // do two edges of the closed ring ([lat, lng]) cross or touch, on the map or on the globe. Runs on every change of a
// shape of up to 5,000 points, so only edges whose boxes meet are tested (on the globe an arc stays inside the box of
// its ends grown by its sagitta)
// the first two edges found that cross or touch, as [i, j] (edge i runs from point i to the next), or null


export var crossingEdges = function crossingEdges(points) {
  var n = points.length;
  if (n < 4) return null;

  var next = function next(i) {
    return i + 1 === n ? 0 : i + 1;
  };

  var flat = new Float64Array(4 * n);

  for (var i = 0; i < n; i++) {
    var a = points[i];
    var b = points[next(i)];
    flat[4 * i] = Math.min(a[0], b[0]);
    flat[4 * i + 1] = Math.max(a[0], b[0]);
    flat[4 * i + 2] = Math.min(a[1], b[1]);
    flat[4 * i + 3] = Math.max(a[1], b[1]);
  }

  var onMap = anyMeetingPair(n, 2, flat, function (i, j) {
    return crossOnMap(points[i], points[next(i)], points[j], points[next(j)]);
  });
  if (onMap) return onMap;
  var xyz = points.map(toXYZ);
  var arcs = [];
  var globe = new Float64Array(6 * n);

  for (var _i2 = 0; _i2 < n; _i2++) {
    var A = xyz[_i2];
    var B = xyz[next(_i2)];
    arcs.push(arcOf(A, B));
    var chord2 = (A[0] - B[0]) * (A[0] - B[0]) + (A[1] - B[1]) * (A[1] - B[1]) + (A[2] - B[2]) * (A[2] - B[2]);
    var grow = 1 - Math.sqrt(Math.max(0, 1 - chord2 / 4)) + TOUCH_RAD * 10;

    for (var k = 0; k < 3; k++) {
      globe[6 * _i2 + 2 * k] = Math.min(A[k], B[k]) - grow;
      globe[6 * _i2 + 2 * k + 1] = Math.max(A[k], B[k]) + grow;
    }
  }

  return anyMeetingPair(n, 3, globe, function (i, j) {
    return crossOnGlobe(arcs[i], arcs[j]);
  });
};
export var isSelfIntersecting = function isSelfIntersecting(points) {
  return !!crossingEdges(points);
};

var samePoint = function samePoint(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}; // a corner used twice: the ring touches itself there, which MongoDB refuses like a crossing


export var hasRepeatedCorner = function hasRepeatedCorner(points) {
  var seen = new Set();

  for (var i = 0; i < points.length; i++) {
    var key = points[i][0] + ',' + points[i][1];
    if (seen.has(key)) return true;
    seen.add(key);
  }

  return false;
}; // ---- the ring rules (what MongoDB needs) ----

var isFinitePair = function isFinitePair(p) {
  return Array.isArray(p) && p.length >= 2 && typeof p[0] === 'number' && typeof p[1] === 'number' && isFinite(p[0]) && isFinite(p[1]);
};
/**
 * Why MongoDB would refuse this ring, or null when it can be stored and matched.
 * @param {Array<[number, number]>} ring closed ring of [lng, lat], exactly what goes into geometry.coordinates[0]
 * @returns {?string} invalid | too_few | not_closed | range | duplicate | cross (i18n: pages.create_area.polygon_guard)
 *
 * Winding order is not checked: MongoDB only reads it for rings near a hemisphere, far beyond every limit here.
 */


export var ringRejectReason = function ringRejectReason(ring) {
  if (!Array.isArray(ring) || !ring.length) return 'too_few';
  if (!ring.every(isFinitePair)) return 'invalid'; // a closed ring repeats its first point, so it needs 4 entries for 3 corners

  if (ring.length < 4) return 'too_few';
  if (!samePoint(ring[0], ring[ring.length - 1])) return 'not_closed';
  var corners = ring.slice(0, -1);
  if (corners.some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        lng = _ref2[0],
        lat = _ref2[1];

    return lng < -180 || lng > 180 || lat < -90 || lat > 90;
  })) return 'range';
  if (hasRepeatedCorner(corners)) return 'duplicate'; // (the rules take [lat, lng], as the editors hold them)

  if (isSelfIntersecting(corners.map(function (p) {
    return [p[1], p[0]];
  }))) return 'cross';
  return null;
}; // the same GeoJSON shape without a position repeated right after itself (a double click in a drawing tool): the same
// polygon, but one MongoDB accepts. Anything else is left as it is

export var withoutRepeatedPositions = function withoutRepeatedPositions(geometry) {
  if (!geometry || !Array.isArray(geometry.coordinates)) return geometry;

  var ring = function ring(r) {
    return Array.isArray(r) ? r.filter(function (p, i) {
      return i === 0 || !Array.isArray(p) || !Array.isArray(r[i - 1]) || !samePoint(p, r[i - 1]);
    }) : r;
  };

  var rings = function rings(rs) {
    return Array.isArray(rs) ? rs.map(ring) : rs;
  };

  if (geometry.type === 'Polygon') return Object.assign({}, geometry, {
    coordinates: rings(geometry.coordinates)
  });
  if (geometry.type === 'MultiPolygon') return Object.assign({}, geometry, {
    coordinates: geometry.coordinates.map(rings)
  });
  return geometry;
}; // ---- the shape rules (per tool, with its limits) ----
// the map repeats the world sideways: a shape drawn wholly on a copy east or west of it is moved back by whole turns of
// 360° (the same place on the globe). One across the date line keeps points past ±180° (the range rule refuses it)

export var wrapToWorld = function wrapToWorld(points) {
  if (!points || !points.length) return points;
  var turns = Math.round(points.reduce(function (sum, p) {
    return sum + p[1];
  }, 0) / points.length / 360);
  return turns ? points.map(function (p) {
    return [p[0], p[1] - 360 * turns];
  }) : points;
}; // drops a closing duplicate and merges points closer than the limit to the previous one

export var cleanRing = function cleanRing(points, limits) {
  var merge = limits.mergeDistanceM || 0;
  var out = [];
  (points || []).forEach(function (p) {
    var prev = out[out.length - 1];
    if (!prev || distanceM(prev, p) >= merge) out.push([p[0], p[1]]);
  });

  while (out.length > 1 && (distanceM(out[0], out[out.length - 1]) < merge || samePoint(out[0], out[out.length - 1]))) {
    out.pop();
  }

  return out;
};
/**
 * Every rule a drawn shape must meet before it may be saved (D18, D27).
 * @param {Array<[number, number]>} points open ring of [lat, lng]
 * @param {Object} limits one of SHAPE_LIMITS
 * @returns {{ ok: boolean, checks: Array<{ key: string, ok: boolean }>, area: number }} the keys double as i18n keys
 *          (pages.free_draw.check_<key> / problem_<key>): points, crossing, range, area_min, area_max, points_max
 */

export var checkShape = function checkShape(points, limits, ringChecked) {
  var count = points.length;
  var area = areaM2(points);

  var unset = function unset(v) {
    return v === null || v === undefined;
  };

  var checks = [{
    key: 'points',
    ok: count >= limits.minPoints
  }, // (ringChecked: ringRejectReason already ran both tests on this ring)
  {
    key: 'crossing',
    ok: !!ringChecked || !isSelfIntersecting(points) && !hasRepeatedCorner(points)
  }, // a map that repeats the world sideways gives points past ±180° to a shape across the date line, which MongoDB
  // refuses (ringRejectReason: range); a shape wholly on a copy of the world is fine (wrapToWorld)
  {
    key: 'range',
    ok: !!ringChecked || wrapToWorld(points).every(function (p) {
      return p[0] >= -90 && p[0] <= 90 && p[1] >= -180 && p[1] <= 180;
    })
  }, {
    key: 'area_min',
    ok: count >= 3 && (unset(limits.minAreaM2) || area >= limits.minAreaM2)
  }, {
    key: 'area_max',
    ok: unset(limits.maxAreaM2) || area <= limits.maxAreaM2
  }, {
    key: 'points_max',
    ok: unset(limits.maxPoints) || count <= limits.maxPoints
  }];
  return {
    ok: checks.every(function (c) {
      return c.ok;
    }),
    checks: checks,
    area: area
  };
};
/**
 * The server's check of a drawn GeoJSON Polygon (one ring, no holes; a MultiPolygon of those where the limits allow
 * it): the ring rules, then the shape rules with the tool's limits, per part. The screens never send a shape that
 * fails it; this is the safeguard behind them (#7).
 * @returns {?string} null when valid, else a ring reason (see ringRejectReason) or a checkShape key
 */

export var geometryRejectReason = function geometryRejectReason(geometry, limits) {
  if (!geometry || !Array.isArray(geometry.coordinates)) return 'invalid';
  var parts;
  if (geometry.type === 'Polygon') parts = [geometry.coordinates];else if (geometry.type === 'MultiPolygon' && limits.multiPolygon) parts = geometry.coordinates;else return 'invalid';
  if (!parts.length) return 'invalid';

  for (var i = 0; i < parts.length; i++) {
    if (!Array.isArray(parts[i]) || parts[i].length !== 1) return 'invalid';
    var ring = parts[i][0];
    var reason = ringRejectReason(ring);
    if (reason) return reason;
    var failed = checkShape(ring.slice(0, -1).map(function (p) {
      return [p[1], p[0]];
    }), limits, true).checks.find(function (c) {
      return !c.ok;
    });
    if (failed) return failed.key;
  }

  return null;
}; // ---- the drag guards (moving a point of a clean shape) ----

/** The shape may not shrink below this share of its starting surface. */

export var MIN_AREA_RATIO = 0.05;
export var MIN_VERTEX_MARGIN_M = 8;
export var VERTEX_MARGIN_RADIUS_FRAC = 0.08;
export var MIN_VERTEX_ANGLE_DEG = 8; // how close points and sides may come: 8 m, or 8% of the shape's radius when that is more

export var editMarginMeters = function editMarginMeters(radiusMeters) {
  return Math.max(MIN_VERTEX_MARGIN_M, VERTEX_MARGIN_RADIUS_FRAC * (radiusMeters || 0));
};
export var meanRadiusMeters = function meanRadiusMeters(points) {
  if (!points || points.length < 2) return MIN_VERTEX_MARGIN_M;
  var c = polygonCentroid(points);
  var sum = 0;

  for (var i = 0; i < points.length; i++) {
    sum += distanceM(c, points[i]);
  }

  return sum / points.length;
}; // [lat, lng] to metres on the plane touching the earth at origin; fine at the size of one drawn shape

var planeAt = function planeAt(origin) {
  var cosLat = Math.cos(rad(origin[0]));
  return function (p) {
    return [(p[1] - origin[1]) * cosLat * 111320, (p[0] - origin[0]) * 110540];
  };
};
/** Surface on the local plane (m²), for comparing a shape with its own start (the ratio guard). */


export var polygonAreaM2 = function polygonAreaM2(points) {
  if (!points || points.length < 3) return 0;
  var toXY = planeAt(polygonCentroid(points));
  var sum = 0;

  for (var i = 0; i < points.length; i++) {
    var a = toXY(points[i]);
    var b = toXY(points[(i + 1) % points.length]);
    sum += a[0] * b[1] - b[0] * a[1];
  }

  return Math.abs(sum) / 2;
};
export var distPointToSegmentMeters = function distPointToSegmentMeters(p, a, b) {
  var toXY = planeAt(a);
  var P = toXY(p);
  var B = toXY(b);
  var len2 = B[0] * B[0] + B[1] * B[1];
  if (len2 < 1e-6) return distanceM(p, a);
  var t = Math.max(0, Math.min(1, (P[0] * B[0] + P[1] * B[1]) / len2));
  var dx = P[0] - t * B[0];
  var dy = P[1] - t * B[1];
  return Math.sqrt(dx * dx + dy * dy);
}; // the point at index keeps the margin to every point that is not its neighbour

export var hasVertexSpacing = function hasVertexSpacing(testPoints, index, marginM) {
  var n = testPoints.length;

  for (var j = 0; j < n; j++) {
    if (j === index || j === (index - 1 + n) % n || j === (index + 1) % n) continue;
    if (distanceM(testPoints[index], testPoints[j]) < marginM) return false;
  }

  return true;
}; // the point at index keeps the margin to every side it is not on

export var hasEdgeClearance = function hasEdgeClearance(testPoints, index, marginM) {
  var n = testPoints.length;

  for (var i = 0; i < n; i++) {
    var j = (i + 1) % n;
    if (i === index || j === index) continue;
    if (distPointToSegmentMeters(testPoints[index], testPoints[i], testPoints[j]) < marginM) return false;
  }

  return true;
};
export var hasMinArea = function hasMinArea(testPoints, originalAreaM2) {
  if (!originalAreaM2 || originalAreaM2 <= 0) return true;
  return polygonAreaM2(testPoints) >= originalAreaM2 * MIN_AREA_RATIO;
};
/** The smaller angle between the two sides at a corner (0–180°), on the local plane. */

export var vertexAngleDeg = function vertexAngleDeg(points, index) {
  var n = points.length;
  if (n < 3) return 180;
  var toXY = planeAt(points[index]);
  var a = toXY(points[(index - 1 + n) % n]);
  var b = toXY(points[(index + 1) % n]);
  var la = Math.sqrt(a[0] * a[0] + a[1] * a[1]);
  var lb = Math.sqrt(b[0] * b[0] + b[1] * b[1]);
  if (la < 1e-6 || lb < 1e-6) return 0;
  var cos = Math.max(-1, Math.min(1, (a[0] * b[0] + a[1] * b[1]) / (la * lb)));
  return Math.acos(cos) * 180 / Math.PI;
};
/** The dragged corner and its two neighbours (dragging one point sharpens the corners next to it too). */

export var hasMinAngles = function hasMinAngles(testPoints, index, minDeg) {
  var floor = minDeg == null ? MIN_VERTEX_ANGLE_DEG : minDeg;
  var n = testPoints.length;
  if (n < 3) return true;
  return [index, (index - 1 + n) % n, (index + 1) % n].every(function (i) {
    return vertexAngleDeg(testPoints, i) >= floor;
  });
};
/**
 * Why a dragged point is refused, in this order, or null when the move is fine.
 * @returns {?string} cross | spacing | edge | angle | area (i18n: pages.create_area.polygon_guard)
 */

export var rejectReasonForVertex = function rejectReasonForVertex(testPoints, index, marginM, originalAreaM2) {
  if (isSelfIntersecting(testPoints)) return 'cross';
  if (!hasVertexSpacing(testPoints, index, marginM)) return 'spacing';
  if (!hasEdgeClearance(testPoints, index, marginM)) return 'edge';
  if (!hasMinAngles(testPoints, index)) return 'angle';
  if (!hasMinArea(testPoints, originalAreaM2)) return 'area';
  return null;
};